import React from 'react';
import { PhoneIcon, XMarkIcon } from '@heroicons/react/24/solid';

export default function IncomingCall({ callerName, callerImage, onAccept, onDecline }) {
  return (
    <div className="tailwind">
			<div className="flex flex-col items-center justify-between h-screen w-full bg-darkBackground text-white px-2 pb-16">
				<div className="flex flex-col items-center flex-grow mt-16">   
          <img
            src={callerImage || '/assets/images/default_profile.png'}
            alt={`${callerName}'s profile`}
            className="w-32 h-32 rounded-full object-cover mb-4"
          />
					<h1 className="font-poppins text-4xl font-bold mb-2">{callerName}</h1>
					<p className="font-poppins text-xl text-gray-300">is calling you...</p>
				</div>

				<div className="flex justify-between w-full max-w-md px-12">
					<button
						onClick={onAccept}
						className="flex flex-col items-center bg-green-600 hover:bg-green-700 p-5 rounded-full"
					>
						<PhoneIcon className="h-9 w-9 text-white" />
					</button>

					<button
						onClick={onDecline}
						className="flex flex-col items-center bg-red-600 hover:bg-red-700 p-5 rounded-full"
					>
						<XMarkIcon className="h-9 w-9 text-white" />
					</button>
				</div>
			</div>
    </div>
  );
}